import { render, staticRenderFns } from "./BillingHistoryPage.vue?vue&type=template&id=50573180&"
import script from "./BillingHistoryPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BillingHistoryPage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BillingHistoryPage.vue?vue&type=style&index=0&id=50573180&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports